import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import BarCodeField from './BarCodeField';
import FormInput from '../../common/components/FormInput';
import FormMultiline from '../../common/components/FormMultiline';

class LabelCol4Form extends React.Component {
  renderDetailField(leftIndex, rightIndex) {
    const leftKeyName = `Key${leftIndex}`;
    const leftValueName = `Value${leftIndex}`;

    const rightKeyName = `Key${rightIndex}`;
    const rightValueName = `Value${rightIndex}`;

    return (
      <tbody>
        <tr key={leftIndex}>
          <td className="category">
            <Field name={leftKeyName}
                   component={FormInput}
                   type="text"
                   className="form-control"
            />
          </td>
          <td className="info">
            <Field name={leftValueName}
                   component={FormInput}
                   type="text"
                   className="form-control"
            />
          </td>
          <td className="category">
            <Field name={rightKeyName}
                   component={FormInput}
                   type="text"
                   className="form-control"
            />
          </td>
          <td className="info">
            <Field name={rightValueName}
                   component={FormInput}
                   type="text"
                   className="form-control"
            />
          </td>
        </tr>
      </tbody>
    );
  }

  render() {
    const {activePLU, handleSubmit, logoUrl, onCancel, petLabel, submitButtonText} = this.props;

    return (
      <div className="row">
        <div className="col-lg-12">
          <form onSubmit={handleSubmit}>
            <div className="four-col label-main">
              <div className="label-logo">
                <img src={logoUrl}/>
              </div>
              <div className="label-title">
                <Field name="line1" 
                       component={FormInput} 
                       type="text" 
                       className="form-control"
                       placeholder={I18n.t('ENTER_NAME')}  
                />
                <Field name="line2" 
                       component={FormInput} 
                       type="text" 
                       className="form-control latin-name"
                       placeholder={I18n.t('ENTER_LATIN_NAME')}
                />
              </div>

              <div className="label-right-col">
                <img src={petLabel.ImageUrl} />
                <div className="price">
                  <Field name="price" 
                         component={FormMultiline} 
                         type="text" 
                         className="form-control txt-price"
                         placeholder={I18n.t('ENTER_PRICE')}
                  />
                </div>
                {activePLU && 
                  <div className="plu">
                    <Field name="plu" 
                           component={FormInput} 
                           type="text" 
                           className="form-control"
                           placeholder={I18n.t('ENTER_PLU')}
                    />
                  </div>}
              </div>

              <div className="label-content">
                <table cellPadding="0" cellSpacing="0">
                  {this.renderDetailField(0, 1)}
                  {this.renderDetailField(2, 3)}
                  {this.renderDetailField(4, 5)}
                </table>
              </div>
              <div className="label-footer">
                <BarCodeField className="barcode"/>
              </div>    
            </div>
            <div className="row no-gutters bottom-buttons">
              <div className="col-sm-12 text-right">
                {onCancel !== undefined && <button type="button" className="btn btn-secondary" onClick={onCancel}>{I18n.t('CANCEL')}</button>}
                <button type="submit" className="btn btn-primary">{submitButtonText}</button> 
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

LabelCol4Form.propTypes = {
  activePLU: PropTypes.bool.isRequired,
  detailFields: PropTypes.array.isRequired,
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  logoUrl: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  petLabel: PropTypes.object.isRequired,
  submitButtonText: PropTypes.string.isRequired
};

export default reduxForm()(LabelCol4Form);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelCol4Form.js
 **/